import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState = false;

export const PAYMENT_TYPES: Array<string> = ["Check", "ACH", "PayPal"];

export interface ICreatePaymentParams {
	paymentAmount: string;
	paymentDate: string;
	paymentType: string;
	paymentDetails: string;
	notes: string;
	invoiceIds: Array<number>;
	adjustmentIds: Array<number>;
}

export const { thunk: createPayment, slice: createPaymentSlice } = getThunkAndSlice<
	ICreatePaymentParams,
	typeof initialState
>({
	initialState,
	path: "/api/Sales/CreatePayment",
	method: "post",
});
